import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as inscripcionesService from '../../services/inscripciones/inscripcionesService';
import {
    classifyInscripcionesError,
    toUpdateInscripcionCursadaPayload
} from '../../services/inscripciones/inscripcionesDto';
import { LookupCursadas } from '../Cursadas/LookupCursadas';
import { LookupAlumnoCarrera } from '../AlumnoCarrera/LookupAlumnoCarrera';
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import Select from '../common/AppSelect';

registerLocale('es', es)

const estadoOptions = [
    { value: 'A', label: 'Activa' },
    { value: 'P', label: 'Pendiente' }
];

export class UpdateInscripcionCursada extends Component {
    static displayName = UpdateInscripcionCursada.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            descripcion: "",
            showErrorMessage: false,
            success: false,
            errorMessage: "",
            showLookupAnios: false,
            showLookupCursada: false,
            tagData: [{ id: "", text: "" }],
            startDate: new Date(),
            endDate: new Date(),
            startInscriptionDate: new Date(),
            endInscriptionDate: new Date(),
            ignorarCorrelatividad: false,
            llamado: "",
            cursada: { cursadaCodigo: 0, cursadaMateriaCodigo: "", cursadaMateriaNombre: "", cursadaPeriodo: "" },
            alumno: { alumnocarreraCod: 0, alumnoNombre: "", alumnoCarrera: 0, alumnoCarreraNombre: "" },
            id: this.props.match.params.id,
            details: this.props.match.params.details,
            valueEstado: null
        };
        this.handleConfirmButton = this.handleConfirmButton.bind(this);
        this.handleDescripcionChangeInput = this.handleDescripcionChangeInput.bind(this);
        this.handleLlamadoChangeInput = this.handleLlamadoChangeInput.bind(this);
        this.handleShowAniosLookup = this.handleShowAniosLookup.bind(this);
        this.handleSelectAnioItem = this.handleSelectAnioItem.bind(this);
        this.handleHideLookup = this.handleHideLookup.bind(this);
        this.handleStartDate = this.handleStartDate.bind(this);
        this.handleEndDate = this.handleEndDate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleEndInscripcionDate = this.handleEndInscripcionDate.bind(this);
        this.handleStartInscriptionDate = this.handleStartInscriptionDate.bind(this);
        this.getPeriodoCursada = this.getPeriodoCursada.bind(this);
        this.getEstadoInscripcion = this.getEstadoInscripcion.bind(this);
        this.handleShowCursadaLookup = this.handleShowCursadaLookup.bind(this);
        this.handleCursadaAnioItem = this.handleCursadaAnioItem.bind(this);
        this.handleCheckBox = this.handleCheckBox.bind(this);
    }

    async componentDidMount() {
        const canAccess = await constantClass.canAccess('WWInscripcionCursada');
        if (canAccess) {
            this.populateData();
        }
    }

    handleCheckBox = (e) => {
        this.setState({ ignorarCorrelatividad: e.target.checked });
    }

    handleConfirmButton = () => {
        var errorMessage = "";
        var isOkToSave = this.isOkToSave();

        if (!isOkToSave) {
            errorMessage = "Todos los campos son obligatorios";
            this.setState({ showErrorMessage: true, errorMessage: errorMessage });
        } else {
            this.saveStudent();
        }
    }

    getPeriodoCursada(periodoCursadaDescripcion) {

        if (periodoCursadaDescripcion == "1") {
            return "Primer Cuatrimestre";
        } else {
            if (periodoCursadaDescripcion == "2") {
                return "Segundo Cuatrimestre";
            }
            else {
                return "Anual";
            }
        }
    }

    async populateData() {
        try {
            const data = await inscripcionesService.getInscripcionCursada(this.state.id);
            const defaultValue = estadoOptions.filter(x => x.value == data.inscripcionCursadaEstado)[0];
            this.setState({
                errorMessage: '',
                cursada: {
                    cursadaCodigo: data.cursadaCod,
                    cursadaMateriaCodigo: data.cursadaCodNavigation.materiaCarreraCod,
                    cursadaMateriaNombre: data.cursadaCodNavigation.materiaNombre.trim(),
                    cursadaPeriodo: this.getPeriodoCursada(data.cursadaCodNavigation.periodoCursadaDescripcion) + " - " + data.cursadaCodNavigation.anioAcademicoDescripcion.trim()
                },
                alumno: {
                    alumnocarreraCod: data.alumnoxCarreraCodNavigation.alumnoxCarreraCod,
                    alumnoNombre: data.alumnoxCarreraCodNavigation.alumnoNombre.trim(),
                    alumnoCarrera: data.alumnoxCarreraCodNavigation.carreraCod,
                    alumnoCarreraNombre: data.alumnoxCarreraCodNavigation.carreraNombre.trim()
                },
                descripcion: data.inscripcionCursadaEstado,
                valueEstado: defaultValue
            });
        } catch (error) {
            const outcome = classifyInscripcionesError(error);
            if (outcome.type === 'timeout') {
                constantClass.RedirectToLogin();
                return;
            }
            this.setState({ errorMessage: outcome.message });
        }
    }

    handleEndInscripcionDate = (date) => {
        this.setState({ endInscriptionDate: date });
    }

    handleStartInscriptionDate = (date) => {
        this.setState({ startInscriptionDate: date });
    }

    handleShowAniosLookup = () => {
        this.setState({ showLookupAnios: true });
    }

    handleShowCursadaLookup = () => {
        this.setState({ showLookupCursada: true });
    }

    handleStartDate = (date) => {
        this.setState({ startDate: date });
    }

    handleEndDate = (date) => {
        this.setState({ endDate: date });
    }

    handleHideLookup = () => {
        this.setState({ showLookupAnios: false });
    }

    handleDescripcionChangeInput = e => {
        this.setState({ descripcion: e.target.value });
    }

    handleLlamadoChangeInput = e => {
        this.setState({ llamado: e.target.value });
    }

    handleSelectAnioItem = (e) => {
        const anioProperties = e.split('%');
        this.setState({
            alumno: {
                alumnocarreraCod: anioProperties[0],
                alumnoNombre: anioProperties[1],
                alumnoCarrera: anioProperties[3],
                alumnoCarreraNombre: anioProperties[2]
            },
            showLookupAnios: false
        });
    }

    handleCursadaAnioItem = (e) => {
        const anioProperties = e.split('%');
        this.setState({
            cursada: {
                cursadaCodigo: anioProperties[0],
                cursadaMateriaCodigo: anioProperties[5],
                cursadaMateriaNombre: anioProperties[1],
                cursadaPeriodo: this.getPeriodoCursada(anioProperties[3]) + "-" + anioProperties[4]
            },
            showLookupCursada: false
        });
    }

    handleChange = (e) => {
        this.setState({ descripcion: e.value, valueEstado: e });
    }

    getEstadoInscripcion(periodoCursadaDescripcion) {

        if (periodoCursadaDescripcion == "A") {
            return "Activa";
        } else {
            if (periodoCursadaDescripcion == "P") {
                return "Pendiente";
            }
            else if (periodoCursadaDescripcion == "G") {
                return "Acta Generada";
            }
            else {
                return "Lista";
            }
        }
    }


    render() {
        if (this.state.success) {
            return <Redirect to="/md-ic" />;
        }

        const isDetail = this.state.details !== '0';
        const title = isDetail ? 'Detalle de Inscripción a Cursada' : 'Modificar Inscripción a Cursada';
        const { loading } = this.state;
        const alumnoDisplay = (this.state.alumno.alumnoNombre + " - " + this.state.alumno.alumnoCarreraNombre).trim();
        const cursadaDisplay = (this.state.cursada.cursadaMateriaNombre.trim() + " - " + this.state.cursada.cursadaPeriodo).trim();
        const estadoLabel = this.getEstadoInscripcion(this.state.descripcion);

        return (
            <div className="md-page md-update-inscripcion-cursada">
                <Link className="md-page__back-link" to="/md-ic">
                    <ChevronLeftIcon />
                    Volver al listado
                </Link>

                <div className="md-page__header">
                    <h1 className="md-page__title">{title}</h1>
                </div>
                <p className="md-page__subtitle">
                    {isDetail
                        ? 'Consulte los datos registrados de la inscripción.'
                        : 'Actualice los datos de la inscripción y guarde los cambios.'}
                </p>

                <div className="md-page__feedback" aria-live="polite" role="status">
                    {this.state.showErrorMessage ? (
                        <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
                    ) : null}
                    {this.state.errorMessage && !this.state.showErrorMessage ? (
                        <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
                    ) : null}
                    {loading ? (
                        <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
                    ) : null}
                </div>

                <div className="md-page__form-card">
                    <div className="md-page__field">
                        <span className="md-page__field-label">Alumno</span>
                        <div className="md-page__picker-block">
                            {!isDetail && !loading ? (
                                <button type="button" className="md-page__picker-link" onClick={this.handleShowAniosLookup}>
                                    Seleccionar alumno
                                </button>
                            ) : null}
                            <div className="md-page__field-readonly">{alumnoDisplay}</div>
                        </div>
                    </div>

                    <div className="md-page__field">
                        <span className="md-page__field-label">Cursada</span>
                        <div className="md-page__picker-block">
                            {!isDetail && !loading ? (
                                <button type="button" className="md-page__picker-link" onClick={this.handleShowCursadaLookup}>
                                    Seleccionar cursada
                                </button>
                            ) : null}
                            <div className="md-page__field-readonly">{cursadaDisplay}</div>
                        </div>
                    </div>

                    <div className="md-page__field">
                        <span className="md-page__field-label">Estado de la inscripción</span>
                        {isDetail ? (
                            <div className="md-page__field-readonly">{estadoLabel}</div>
                        ) : (
                            <Select
                                className="md-page__field-select"
                                options={estadoOptions}
                                value={this.state.valueEstado}
                                disabled={loading}
                                onChange={this.handleChange}
                            />
                        )}
                    </div>

                    {!isDetail ? (
                        <div className="md-page__field">
                            <label className="md-page__field-label">
                                <input
                                    type="checkbox"
                                    checked={this.state.ignorarCorrelatividad}
                                    onChange={this.handleCheckBox}
                                    disabled={loading}
                                />
                                {' '}Ignorar verificación de correlatividad
                            </label>
                        </div>
                    ) : null}

                    {!isDetail ? (
                        <div className="md-page__form-actions">
                            <button
                                type="button"
                                className="md-page__form-btn md-page__form-btn--primary"
                                onClick={this.handleConfirmButton}
                                disabled={loading}
                            >
                                Guardar cambios
                            </button>
                        </div>
                    ) : null}
                </div>

                {this.state.showLookupAnios ? (
                    <LookupAlumnoCarrera selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
                ) : null}
                {this.state.showLookupCursada ? (
                    <LookupCursadas carreraCod={this.state.alumno.alumnoCarrera} selectItem={this.handleCursadaAnioItem} hideLookup={this.handleHideLookup} />
                ) : null}
            </div>
        );
    }

    isOkToSave() {
        return (this.state.descripcion.length > 0);
    }

    async saveStudent() {
        this.setState({ showErrorMessage: false, loading: true });
        try {
            await inscripcionesService.updateInscripcionCursada(toUpdateInscripcionCursadaPayload({
                id: this.state.id,
                cursadaCod: this.state.cursada.cursadaCodigo,
                alumnoxCarreraCod: this.state.alumno.alumnocarreraCod,
                materiaCarreraCod: this.state.cursada.cursadaMateriaCodigo,
                estado: this.state.descripcion,
                ignorarCorrelatividad: this.state.ignorarCorrelatividad
            }));
            this.setState({ loading: false, success: true, errorMessage: '' });
        } catch (error) {
            const outcome = classifyInscripcionesError(error);
            if (outcome.type === 'timeout') {
                constantClass.RedirectToLogin();
                return;
            }
            this.setState({
                loading: false,
                success: false,
                errorMessage: outcome.message
            });
        }
    }
}
